export default __webpack_public_path__ + "static/media/bus.5e25e059.svg";